import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { TUser } from '../../utils/types/agrocraftArtisan';

const initialState: TUser | null = null;

export const authUserSlice = createSlice({
  name: 'authUserSlice',
  initialState: initialState as TUser | null,
  reducers: {
    updateAuthUser: (
      _state,
      action: PayloadAction<TUser>
    ) => action.payload,
    resetAuthUser: () => null,
  },
});

export const { updateAuthUser, resetAuthUser } =
  authUserSlice.actions;

export default authUserSlice.reducer;
